import { DialogContent, Dialog, Box, Grid, Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import CustodiansListTable from '../Locations/Custodians/CustodiansListTable';
import CustodianSearch from './Search/CustodianSearch';
import FacilitySearch from './Search/FacilitySearch';
import useFetchCustodiansSearchResult from '../../hooks/Locations/useFetchCustodiansSearchResult';

interface AssignEntityDialogProps {
  open: boolean;
  handleClose: () => void;
  associatedEntities: any[];
  onItemSelected: (item: any) => void;
  entityLabel: string;
}

export default function AssignEntityDialog({
  open,
  handleClose,
  associatedEntities,
  onItemSelected,
  entityLabel,
}: Readonly<AssignEntityDialogProps>) {
  const [hasUserStartedSearching, setHasUserStartedSearching] =
    useState<boolean>(false);
  const [pageNo, setPageNo] = useState(0);
  const { data, pageChanged, searchChanged, isLoading } = useFetchCustodiansSearchResult();

  const onSearchChanged = async (value?: string, entityType?: string) => {
    if (value) {
      setPageNo(0);
      searchChanged(value, entityType);
      setHasUserStartedSearching(true);
    } else {
      setHasUserStartedSearching(false);
    }
  };

  const onChooseItem = (item: any) => {
    onItemSelected(item);
    handleClose();
  };

  useEffect(() => {
    setHasUserStartedSearching(false);
  }, [open]);

  const isCustodianAlreadyAdded = (entities: any[], associatedEntities: any[]) => {
    return entityLabel == "Custodian" && entities?.length === 1 && entities?.some((entity) =>
      associatedEntities?.some((assoc) => assoc.childEntityId === entity.id)
    );
  };

  return (
    <Box>
      <Dialog
        maxWidth={'xl'}
        open={open}
        onClose={handleClose}
        aria-labelledby="assign-entity-dialog"
      >
        <DialogContent>
          <Box width={1000}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box>
                  {entityLabel == "Custodian" ?
                    <CustodianSearch
                      onSearchChanged={onSearchChanged}
                    /> :
                    <FacilitySearch
                      onSearchChanged={onSearchChanged}
                    />
                  }

                  <CustodiansListTable
                    custodians={
                      hasUserStartedSearching
                        ? data?.entities?.filter(
                          (o: any) =>
                            !associatedEntities.some((a) => a.childEntityId === o.id),
                        )
                        : []
                    }
                    count={data.count}
                    isLoading={isLoading}
                    unmountCollapsedOnExit={true}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    onPageChanged={pageChanged}
                    usePagination={true}
                    showSelectBtn={true}
                    selectBtnClicked={onChooseItem}
                    showNoRecordsFoundMessage={hasUserStartedSearching && !isCustodianAlreadyAdded(data?.entities, associatedEntities)}
                  />
                  {hasUserStartedSearching && isCustodianAlreadyAdded(data?.entities, associatedEntities) && (
                    <Alert
                      severity="warning"
                      sx={{
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        margin: 2,
                        padding: 2,
                        width: '100%',
                      }}
                    >
                      <strong>The custodian you're searching for has already been added.</strong>
                      <div style={{ marginLeft: '10px', fontSize: '0.9rem' }}>
                        Please try searching for a different custodian or review the existing associations.
                      </div>
                    </Alert>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
